// @flow
import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import { hot } from 'react-hot-loader/root'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { MDXContent } from '../MDXContent'
import { Waypoint } from 'react-waypoint'

// TODO Set the correct article ID here
const ARTICLE_ID = '29441577'
const ADDITIONAL_SHARES = 874

function AppComponent() {
  return (
    <div className='index'>
      <Masthead
        articleId={ARTICLE_ID}
        additionalShares={ADDITIONAL_SHARES}
        inverted
      />
      <ThemeSwitch />

      {/* TODO Replace the following segment with your project cover */}
      <header className='ui container titleImage'>
        {/* <img src='images/baskast.jpg' /> */}

        <h1 className='headline'>
          <br />
          <span>Bas Kast im Interview</span>
          <br />
          «Gesund essen? Das ist einfach»
        </h1>
      </header>
      <div className='ui container'>
        <div className='ta secondary caption'>
          {' '}
          Litt mit 40 an Herzrhythmusstörungen: Bas Kast. Foto: Mike Meyer
        </div>
      </div>

      {/* TODO And probably remove the following segment and replace it with
       your own content */}
      <div className='ui vertical segment '>
        <div className='ui text container'>
          <div className=' ta lead'>
            Bestsellerautor Bas Kast weiss, was man essen muss, um alt zu
            werden. Das Buch «Ernährungskompass» steht seit Monaten ganz oben
            auf der «Spiegel»-Sachbuchliste. Jetzt hat er mit einem Kochbuch
            nachgelegt. Wir haben nach der ultimativ gesunden Kost gefragt. Und
            zeigen exklusiv vier seiner Rezepte.
          </div>
          <div className=' ta author'>Von Silvia Aeschbach</div>
        </div>
      </div>
      {/* TEXT */}
      <div className='ui vertical segment interviewText'>
        <div className='ui text container'>
          <MDXContent file={'text_p1.mdx'} />
        </div>
      </div>

      {/* REZEPT */}
      <div className='ui vertical segment rezept left grey'>
        <div
          className='imageHolder'
          style={{ backgroundImage: 'url("images/rezept_4.jpg")' }}
        />
        <div className='textHolder'>
          <MDXContent file={'rezept_4.mdx'} wrapperClass='zutaten' />
        </div>
      </div>

      {/* TEXT */}
      <div className='ui vertical segment interviewText'>
        <div className='ui text container'>
          <MDXContent file={'text_p2.mdx'} />
        </div>
      </div>

      {/* REZEPT */}
      <div className='ui vertical segment rezept right'>
        <div
          className='imageHolder'
          style={{ backgroundImage: ' url("images/rezept_3.jpg")' }}
        />
        <div className='textHolder'>
          <MDXContent file={'rezept_3.mdx'} wrapperClass='zutaten' />
        </div>
      </div>
      <Waypoint
        scrollableAncestor={window}
        onEnter={event => {
          if (event.previousPosition === 'below') {
            window.dataLayer = window.dataLayer || []
            // eslint-disable-next-line @typescript-eslint/camelcase
            window.dataLayer.push({
              event: 'content30',
              // eslint-disable-next-line @typescript-eslint/camelcase
              event_action: '',
              // eslint-disable-next-line @typescript-eslint/camelcase
              event_label: ''
            })
          }
        }}
      />
      {/* TEXT */}
      <div className='ui vertical segment interviewText'>
        <div className='ui text container'>
          <MDXContent file={'text_p3.mdx'} />
        </div>
      </div>

      {/* REZEPT */}
      <div className='ui vertical segment rezept right'>
        <div
          className='imageHolder'
          style={{ backgroundImage: ' url("images/rezept_1.jpg")' }}
        />
        <div className='textHolder'>
          <MDXContent file={'rezept_1.mdx'} wrapperClass='zutaten' />
        </div>
      </div>
      <Waypoint
        scrollableAncestor={window}
        onEnter={event => {
          if (event.previousPosition === 'below') {
            window.dataLayer = window.dataLayer || []
            // eslint-disable-next-line @typescript-eslint/camelcase
            window.dataLayer.push({
              event: 'content60',
              // eslint-disable-next-line @typescript-eslint/camelcase
              event_action: '',
              // eslint-disable-next-line @typescript-eslint/camelcase
              event_label: ''
            })
          }
        }}
      />
      {/* TEXT */}
      <div className='ui vertical segment interviewText'>
        <div className='ui text container'>
          <MDXContent file={'text_p4.mdx'} />
        </div>
      </div>
      {/* REZEPT */}
      <div className='ui vertical segment rezept left grey'>
        <div
          className='imageHolder'
          style={{ backgroundImage: ' url("images/rezept_2.jpg")' }}
        />
        <div className='textHolder'>
          <MDXContent file={'rezept_2.mdx'} wrapperClass='zutaten' />
        </div>
      </div>
      {/* TEXT */}
      <div className='ui vertical segment interviewText'>
        <div className='ui text container'>
          <MDXContent file={'text_p5.mdx'} />
        </div>
      </div>

      <div className='ui vertical segment '>
        <div className='ui text container biobox'>
          <img className='left' src='images/buch_2.png' /> Der
          deutsch-niederländische Wissenschaftsjournalist und Autor{' '}
          <b>Bas Kast</b> (46) schrieb 2018 mit
          <b>
            «Der Ernährungskompass – Das Fazit aller wissenschaftlichen Studien
            zum Thema Ernährung»
          </b>{' '}
          einen Bestseller, der zum «Wissensbuch des Jahres 2018» gekürt wurde.
          Der Ratgeber steht immer noch auf der Schweizer
          Sachbuch-Bestsellerliste. <br />
          <br />
          <img className='right' src='images/buch.png' />
          Sein neues Buch
          <b>«Der Ernährunskompass – Das Kochbuch»</b> fasst 111 Rezepte
          zusammen, die auf seinen Recherchen beruhen, und die sowohl gesund wie
          schmackhaft sein sollen. Beide Bücher sind im Verlag C. Bertelsmann
          erschienen.
        </div>
      </div>

      <Footer
        articleId={ARTICLE_ID}
        additionalShares={ADDITIONAL_SHARES}
        questions={[
          'Wie informativ war das Interview?',
          'Wie lecker finden Sie die Rezepte?',
          'Wie gefällt Ihnen die Gestaltung?'
        ]}
        credits={[
          ['Interview', 'Silvia Aeschbach'],
          ['Fotos', 'Mike Meyer'],
          [
            'Umsetzung',
            'Marc Brupbacher, Sebastian Broschinski, Interaktiv-Team'
          ]
        ]}
      />
    </div>
  )
}

export default hot(AppComponent)
